import Header from './components/Header';

import Collections from './components/Collections';
import GoldenTicket from './components/GoldenTicket';
import NewsLetter from './components/NewsLetter';
import Footer from './components/Footer';
import MainSection from './components/MainSection';
import GlobalStyle from './globalStyles';


function App() {
  return (
    <>
    <GlobalStyle />
      <Header />
      <MainSection />
      <Collections />
      <GoldenTicket />
      <NewsLetter />
      <Footer />
    </ >

  );
}

export default App;
